import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "../../../../Services/Api/createApi";

import { store } from "../..";

const getRatingsQueryFun = (sessionId, token) => {
  return api({
    url: `/get_video_rates?id=${sessionId}`,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

const getCourseRatesQueryFun = (sessionId, token) => {
  return api({
    url: `/get_course_raters?id=${sessionId}`,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

const addRatingMutationFun = (payload) => {
  const token = store.getState().Auth.userInfo.token;

  return api({
    method: "POST",
    url: `/rate_video`,
    data: payload,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

const addCourseRateMutationFun = (payload) => {
  const token = store.getState().Auth.userInfo.token;
  return api({
    method: "POST",
    url: `/add_course_rate`,
    data: payload,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

//React-query

//@Query
export const useGetVideoRatesQuery = (sessionId, token) => {
  return useQuery({
    queryKey: ["get-video-rates-by-id", sessionId],
    queryFn: () => getRatingsQueryFun(sessionId, token),
    select: (data) => data.data.data,
  });
};

export const useGetCourseRatesQuery = (sessionId, token) => {
  return useQuery({
    queryKey: ["get-course-rates-by-id", sessionId],
    queryFn: () => getCourseRatesQueryFun(sessionId, token),
    select: (data) => data.data.data,
  });
};

// @Mutation
export const useAddVideoRateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addRatingMutationFun,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-video-rates-by-id"] });
    },
  });
};

export const useAddCourseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addCourseRateMutationFun,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-course-rates-by-id"] });
    },
  });
};
